module.exports = __webpack_public_path__ + "static/assets/e907215a8ec7588ee9f9d64f39adbb73.svg";